import { createFileRoute } from "@tanstack/react-router";
import FiveDayTmsPage from "@/pages/learn/FiveDayTmsPage";
import { page5DayTms } from "@/pages/learn/learnData5DayTms";
export const Route = createFileRoute("/learn/5-day-tms-treatment")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Where Can I Get 5-Day TMS Treatment? | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "5-day TMS treatment: not every accelerated TMS is SAINT®. Different protocols, why names matter, treatment frequency, targeting methods, and questions to.",
        },
        {
          property: "og:title",
          content: "Where Can I Get 5-Day TMS Treatment? | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "5-day TMS treatment: not every accelerated TMS is SAINT®. Different protocols, why names matter, treatment frequency, targeting methods, and questions to.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/learn/5-day-tms-treatment",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/5-day-tms-treatment",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(page5DayTms.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <FiveDayTmsPage />;
}
